import { NgModule } from '@angular/core';
import { DashPaymentsComponent } from './dash-payments.component';
import { SharedModule } from '../../../../shared/shared.module';
import { PaymentDetailDialogModule } from '../../../shared/payment-detail-dialog/payment-detail-dialog.module';
import { DatatableModule } from '../../../../shared/datatable/datatable.module';
import { ModalModule } from '../../../../shared/modal/modal.module';
import { PaymentGroupsService } from '../../../../../services/payment/payment-groups.service';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { LegfiCurrencyPipeModule } from '../../../../../pipes/format/legfi-currency.module';
import { LegfiCurrencyPipe } from '../../../../../pipes/format/legfi-currency.pipe';
import { SingleDateRangeSimpleModule } from '../../../shared/report-filters/single-date-range-simple/single-date-range-simple.module';
import { PaymentsTableModule } from '../../../payments/incoming-payments/payments-table/payments-table.module';
import { MaterialSearchModule } from '../../../../shared/material-search/material-search.module';

@NgModule({
    imports: [
        SharedModule,
        PaymentDetailDialogModule,
        DatatableModule,
        ModalModule,
        NgbModule,
        LegfiCurrencyPipeModule,
        SingleDateRangeSimpleModule,
        PaymentsTableModule,
        MaterialSearchModule,
    ],
    exports: [
        DashPaymentsComponent,
    ],
    declarations: [DashPaymentsComponent],
    providers: [
        PaymentGroupsService,
        LegfiCurrencyPipe,
    ],
})
export class DashPaymentsModule
{
}
